module.exports = __webpack_public_path__ + "img/One-Stop-2.a3cca967.png";